import React from 'react'
import { Avvia_Partita } from '../../Components'
const Avvia_Partita2 = () => {
    return (
        <div>
            <Avvia_Partita no={3} />
        </div>
    )
}

export default Avvia_Partita2
